import Element from "../Element";
import Renderable from "Component/Renderable";
import UIScrollComponent from "Component/UI/Scroll";

export default class SeasonPassRankScroll extends Element {
    public create(params: any): void {
        super.create({
            type: 'group',
            name: 'seasonpass_rank_scroll',
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
                ...params.layout,
            },
            components: [
                {
                    type: 'scroll',
                    data: {
                        friction: 0.9,
                        direction: 'x',
                        scrollWidth: params.scrollWidth,
                        scrollHeight: params.scrollHeight,
                    },
                },
                {
                    type: 'mask',
                    data: {
                        offset: [0, 0, 0, 0],
                    },
                },
            ],
            ...params,
        });
        const scroll: UIScrollComponent = this.getComponent(UIScrollComponent);

        scroll.direction = 'x';
        scroll.friction = 0.9;

        this.addComponent(Renderable);
    }
}
